// Shared UI helpers for the Incidents (skadesak) module.
// Used from both the admin and the customer views.

export const STATUS_META = {
    open:              { no: "Åpen",             en: "Open",              cls: "bg-red-100 text-red-700 border-red-300" },
    in_progress:       { no: "Under behandling", en: "In progress",       cls: "bg-cyan-100 text-cyan-800 border-cyan-300" },
    waiting_customer:  { no: "Venter på kunde",  en: "Awaiting customer", cls: "bg-amber-100 text-amber-800 border-amber-300" },
    resolved:          { no: "Løst",             en: "Resolved",          cls: "bg-emerald-100 text-emerald-800 border-emerald-300" },
    closed:            { no: "Lukket",           en: "Closed",            cls: "bg-slate-200 text-slate-700 border-slate-300" },
};

export const SEVERITY_META = {
    minor:    { no: "Mindre",    en: "Minor",    cls: "text-slate-600" },
    moderate: { no: "Moderat",   en: "Moderate", cls: "text-amber-700" },
    major:    { no: "Alvorlig",  en: "Major",    cls: "text-orange-700" },
    critical: { no: "Kritisk",   en: "Critical", cls: "text-red-700 font-semibold" },
};

export function statusLabel(status, lang = "no") {
    return (STATUS_META[status] || { no: status, en: status })[lang];
}
export function severityLabel(sev, lang = "no") {
    return (SEVERITY_META[sev] || { no: sev, en: sev })[lang];
}

export function fmtDt(iso, lang = "no") {
    if (!iso) return "";
    return new Date(iso).toLocaleString(lang === "no" ? "nb-NO" : "en-GB");
}
